import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=0677a6c8&scoped=true&"
import script from "./MFA.vue?vue&type=script&lang=js&"
export * from "./MFA.vue?vue&type=script&lang=js&"
import style0 from "./MFA.vue?vue&type=style&index=0&id=0677a6c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0677a6c8",
  null
  
)

export default component.exports